import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';  
import { Navigate, Outlet, useLocation } from 'react-router-dom';  
  
import { LoginContext } from './App';
import { NavigateSmart } from './Common';


export const PrivateRoute = () => {
    const login = useContext(LoginContext);
    
    const location = useLocation();

    useLayoutEffect(() => {
        if(!login.checkingLogin && !login.loggedIn) {
            login.navigateUrlAfterLogin.current = location.pathname + location.search;
            // console.log(login.navigateUrlAfterLogin.current);
        }
    }, [login.loggedIn])

    return (
        login.checkingLogin ?
            <div></div>
        :
            login.loggedIn ?
                <Outlet />
            :
                <NavigateSmart to="/login"/>
    );
};

export default PrivateRoute
